export const APPLE_PAY_CONFIG_NAME = "applePay";
